<template>
  <v-layout>
    <v-flex>
      <v-card class="pa-6 pt-4 mt-10">
        <v-card-title>
          Containers
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            class="table-search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details>
          </v-text-field>
        </v-card-title>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="containers"
          :server-items-length="pagination.total"
          :items-per-page="pagination.per_page"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
          :loading="loading"
          loading-text="Loading Containers..."
          item-key="id"
          no-data-text="No Containers Found"
          :options.sync="options"
          ref="table">

          <template v-slot:[`item.name`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-1">
                mdi-cube-outline
              </v-icon>
              {{ item.name }}
            </div>
          </template>

          <!-- <template v-slot:[`item.status`]="{ item }">
            <span>
              <v-chip text-color="white" v-if="item.status == 0" small><strong>{{ getStatusName(item.status) }}</strong></v-chip>
              <v-chip text-color="white" color="success" v-if="item.status == 1" small><strong>{{ getStatusName(item.status) }}</strong></v-chip>
              <v-chip text-color="white" color="warning" v-if="item.status == 2" small><strong>{{ getStatusName(item.status) }}</strong></v-chip>
            </span>
          </template> -->

          <template v-slot:[`item.date_created`]="{ item }">
            {{ item.date_created | moment("MMM D, YYYY") }}
          </template>

          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="primary"
                  @click="viewItem(item)">
                  mdi-magnify
                </v-icon>
              </template>
              <span>View</span>
            </v-tooltip>
          </template>

        </v-data-table>
      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>

    </v-flex>
  </v-layout>

</template>




<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'

  export default {
    name: 'AdminContainersPage',
    data() {
      return {
        adminNamespace: 'admin',
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        error:{
          show: false,
          status: '',
          error: '',
          messages: {}
        },
        firstLoad: true,
        loading: false,
        search: '',
        awaitingSearch: false,
        selected: [],
        containers: [],
        agents: [],
        warehouses: [],
        statuses: [],
        pagination: {
          page: 1,
          per_page: 1,
          total: 0,
          next: 0
        },
        options: {},
        headers: [
          {
            text: 'Name',
            align: 'start',
            value: 'name',
            sortable: false,
            width: 180
          },
          {
            text: 'Reference',
            align: 'start',
            value: 'refs',
            sortable: false,
          },
          {
            text: 'Shipping Marks',
            value: 'shipping_marks',
            sortable: false,
            width: 400
          },
          {
            text: 'Count',
            align: 'center',
            value: 'bookings_cnt',
            sortable: false
          },
          // {
          //   text: 'Created At',
          //   align: 'start',
          //   value: 'date_created',
          //   sortable: false,
          //   width: 180
          // },
          {
            text: 'Action',
            value: 'action',
            align: 'center',
            sortable: false,
            width: 80
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['getUserInitial']),
      hasSelected: function(){
        return this.selected.length != 0 ? false : true
      }
    },
    watch: {
      options: {
        handler () {
          this.getContainers()
        },
        deep: true,
      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.options.page = 1
            this.getContainers()
            this.awaitingSearch = false;
          }, 1000); // 1 sec delay
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
      viewItem (item) {
        this.$router.push({ name: 'container-view', params: { name: item.name } })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      getContainers () {
        if (this.loading) {
          return false
        }

        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let sorting = []
        let params = []

        if (sortBy.length === 1 && sortDesc.length === 1) {
          sortBy.forEach(function (item, index) {
            let sort = 'ASC'
            if (!sortDesc[index]) {
              sort = 'DESC'
            }
            sorting.push(item+'='+sort)
          });
        }

        if (this.search.length > 0){
          params.push('&search='+this.search)
        }

        if(!this.firstLoad){
          this.$router.push({ name: 'containers-page', params: { page: page }})
        }

        this.firstLoad = false

        this.loading = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/containers?page='+ page + '&per_page=' + itemsPerPage + params.join())
          .then(response => {
            this.containers = response.data.containers

            if (response.data.pagination) {
              let pagination = response.data.pagination

              this.pagination.total = pagination.count
            }

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      if(this.$route.params.page){
        this.options.page = parseInt(this.$route.params.page)
      }
    },
    components: {
      SnackBar
    },
  }
</script>
